import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = 'https://carriera-backend.onrender.com/api';

// Shared master list of industries, used as <datalist> options across
// Jobs, Clients and Candidates forms. Typing a new value and blurring
// the field adds it to the shared list for next time.
export default function useIndustries() {
  const [industries, setIndustries] = useState([]);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/industries`, { headers })
      .then(res => setIndustries(res.data))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addIndustry = useCallback((name) => {
    const trimmed = (name || '').trim();
    if (!trimmed) return;
    setIndustries(prev => prev.includes(trimmed) ? prev : [...prev, trimmed].sort());
    if (industries.includes(trimmed)) return;
    axios.post(`${API}/industries`, { name: trimmed }, { headers }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [industries]);

  return { industries, addIndustry };
}
